
export let endpoint = `https://api.bidfhire.in/`;
export let apiEndPoint = `${endpoint}/api`;
export let imageEndpoint =   `${endpoint}/media/`;
export let APP_ENV = "production";
export function updateEnv(e) {
    APP_ENV = e
    if(e == "qa"){
        endpoint = `https://adminapi.bidfhire.in/`;
        apiEndPoint = `${endpoint}/api`;
        imageEndpoint =   `${endpoint}/media/`;
    }
    else if(e == "production"){
        endpoint = `https://api.bidfhire.in/`;
        apiEndPoint = `${endpoint}/api`;
        imageEndpoint =   `${endpoint}/media/`;
    }
    localStorage.setItem('env', e)
} 